import React, {ReactNode} from 'react';
import axios from "axios";
import {userService} from "./services/UserService";
import NavBar from "./CropSense/navigation/NavBar";
import CustomSnackbar from "./CropSense/navigation/CustomSnackbar";
import {IStore} from "./store/reducers";
import actionTypes from "./store/actionTypes";
import {IPointCoords, INotificacion, IParcela, ISections} from "./types";
import {connect} from "react-redux";

import Principal from "./CropSense/sections/principal/Principal";
import CrearParcela from "./CropSense/sections/crear_parcela/CrearParcela";
import Propiedades from "./CropSense/sections/propiedades/Propiedades";
import GestionUsuarios from "./CropSense/sections/gestion_usuarios/GestionUsuarios";
import Visualizador from "./CropSense/sections/visualizador/Visualizador";
import RiegoNeto from "./CropSense/sections/riego_neto/RiegoNeto";
import SubirDatos from "./CropSense/sections/subir_datos/SubirDatos";
import Configuracion from "./CropSense/sections/configuracion/Configuracion";
import Caracterizacion from "./CropSense/sections/caracterizacion/Caracterizacion";
import EstacionesSuelo from "./CropSense/sections/estaciones/Estaciones";

import RiegoNetoMobile from "./CropSenseMobile/sections/riego_neto/RiegoNeto"
import PrincipalMobile from "./CropSenseMobile/sections/principal/MobilePrincipal"
import NavBarMobile from "./CropSenseMobile/navigation/MobileNavBar"
import VisualizadorMobile from "./CropSenseMobile/sections/visualizador/Visualizador"
import MobileConfiguracion from "./CropSenseMobile/sections/configuracion/MobileConfiguracion";
import MobileCaracterizacion from "./CropSenseMobile/sections/caracterizacion/MobileCaracterizacion";


import Notificacion from "./dialogs/Notificacion";
import Loading from "./dialogs/Loading";
import ActivarCuenta from "./dialogs/ActivarCuenta";
import MobileActivarCuenta from "./dialogs/MobileActivarCuenta";
import CrearNota from "./dialogs/CrearNota";
import EditarNota from "./dialogs/EditarNota";
import EstacionSensores from "./dialogs/EstacionSensores";
import MobileCrearNota from "./dialogs/MobileCrearNota";
import MobileEditarNota from "./dialogs/MobileEditarNota";
import ConfirmacionEliminar from "./dialogs/ConfirmacionEliminar";
import ConfirmacionEliminarUsuario from "./dialogs/ConfirmacionEliminarUsuario";
import NewUser from "./dialogs/NewUser";
import Estaciones from "./dialogs/Estaciones";


import {getCenterZoom} from "./tools/getCenterZoom";
import {LatLngTuple} from "leaflet";


import {isBrowser} from "react-device-detect";
import {CircularProgress} from "@material-ui/core";
import {resolucion_tablet} from "./tools/resolucion";


const config = require('./config.json');
const texts = require('./texts/main.json')



interface IProps {
    closeNotification(): void
    setParcelas(parcelas: IParcela[]): void
    setUsuarios(usuarios: string[]): void
    selectSection(section: ISections): void
    setLevel(level: number): void
    setPrincipalUsuario(usuario: string): void
    setElTiempoLatLon(elTiempoLatLon: IPointCoords): void
    setParcela(parcela: string): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    setRiego(riego: Record<string, Record<string, number>>): void
    setPronostico(pronostico: Record<string, Record<string, number>>): void
    notify(notification: INotificacion): void
    Cargando(cargando: boolean): void
    Reload(reload: boolean): void
    activarCuenta(callback: boolean):void
    changeLanguage(idioma: string): void
    setEstaciones(estaciones: Record<string, any>[]): void
    setSensores(sensores: Record<string, any>[]): void
    notification: INotificacion | null
    section: ISections
    parcelas: IParcela[]
    usuario: string
    cargando: boolean
    reload: boolean
    idioma: string
    pronostico: Record<string, Record<string, number>>
}


interface IState {
    menu: boolean
    secciones: ISections[]
    text: Record<string, string>
}

class CropSenseApp extends React.Component<IProps, IState> {

    state = {
        menu: false,
        secciones: ['Gestión de usuarios'] as ISections[],
        text: texts[this.props.idioma]
    }

    delay = (ms: number) => new Promise(res => setTimeout(res, ms));

    getPronostico = async (id: string) => {
        let counter = 0
        while (counter < 5) {
            let date = new Date()
            date.setDate(date.getDate() - counter)
            let fecha = date.toISOString().split('T')[0].split('-').join('_')

            if (userService.getUser() === 'demo') {
                const data = {
                    "2021-08-23": {
                        "lluvia": 0,
                        "v_viento": 23,
                        "v_raf_viento": 49,
                        "t_max": 40,
                        "t_min": 24,
                        "cielo_id": 2,
                        "nubosidad": 12
                    },
                    "2021-08-24": {
                        "lluvia": 7,
                        "v_viento": 23,
                        "v_raf_viento": 48,
                        "t_max": 33,
                        "t_min": 22,
                        "cielo_id": 12,
                        "nubosidad": 61
                    },
                    "2021-08-25": {
                        "lluvia": 0,
                        "v_viento": 19,
                        "v_raf_viento": 36,
                        "t_max": 33,
                        "t_min": 18,
                        "cielo_id": 1,
                        "nubosidad": 7
                    },
                    "2021-08-26": {
                        "lluvia": 0,
                        "v_viento": 12,
                        "v_raf_viento": 28,
                        "t_max": 32,
                        "t_min": 17,
                        "cielo_id": 1,
                        "nubosidad": 0
                    },
                    "2021-08-27": {
                        "lluvia": 0,
                        "v_viento": 19,
                        "v_raf_viento": 39,
                        "t_max": 32,
                        "t_min": 18,
                        "cielo_id": 1,
                        "nubosidad": 5
                    }
                }
                this.props.setPronostico(data as Record<string, Record<string, number>>)
                counter = 100
            } else {
                axios.get(
                    config.url + `/static/visualizador/pronostico_tiempo/${id}/${fecha}.json`,
                    {
                        auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }
                    })
                    .then((res) => {
                        this.props.setPronostico(res.data)
                        counter = 100
                    })
                    .catch(async () => {
                        counter += 1
                    })
                await this.delay(1000)
            }
        }
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }

        if (this.props.usuario !== nextProps.usuario) {
            for (const i in this.props.parcelas) {
                if (this.props.parcelas[i].propietario.split(',').includes(nextProps.usuario)) {
                    this.props.setParcela(this.props.parcelas[i].id)
                    const center = getCenterZoom(this.props.parcelas[i].lat_lon).center
                    this.props.setZoom(17)
                    this.props.setCenter(center)
                    this.props.setElTiempoLatLon({
                        lat: center[0],
                        lon: center[1]
                    })
                    const url: string = config.url+`/calcula/riego?parcela=${this.props.parcelas[i].id}`
                    this.props.Cargando(true)
                    axios.get(
                        url,
                        {auth: {
                                username: `${userService.getUser()}`,
                                password: `${userService.getPass()}`
                            }})
                        .then((res) => {
                            this.props.setRiego(res.data)
                            this.props.Cargando(false)
                        })
                        .catch(() => {
                            this.props.Cargando(false)
                        })

                    this.getPronostico(this.props.parcelas[i].id)

                    break
                }
            }
        }
        return true
    }

    componentDidMount() {
        axios.get(
            config.url+'/user/connection',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .catch(() => {
                userService.logout()
            })

        axios.get(
            config.url+'/get/usuario',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: Record<string, number|string|null>}) => {
                if (res.data['confirmado'] as number === 0) this.props.activarCuenta(true)
                let lang = "es"
                if (res.data.lang !== null)
                    lang = res.data.lang as string
                this.props.changeLanguage(lang)
            })
            .catch(() => {})

        axios.get(
            config.url+'/init',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: IParcela[] }) => {
                this.props.setParcelas(res.data)
                for (const i in res.data) {
                    if (res.data[i].propietario.split(',').includes(this.props.usuario)) {
                        this.props.setParcela(res.data[i].id)
                        const center = getCenterZoom(res.data[i].lat_lon).center
                        this.props.setZoom(17)
                        this.props.setCenter(center)
                        this.props.setElTiempoLatLon({
                            lat: center[0],
                            lon: center[1]
                        })

                        const url: string = config.url+`/calcula/riego?parcela=${res.data[i].id}`
                        this.props.Cargando(true)
                        axios.get(
                            url,
                            {auth: {
                                    username: `${userService.getUser()}`,
                                    password: `${userService.getPass()}`
                                }})
                            .then((res) => {
                                this.props.setRiego(res.data)
                                this.props.Cargando(false)
                            })
                            .catch(() => {
                                this.props.Cargando(false)
                            })

                        this.getPronostico(this.props.parcelas[i].id)

                        break
                    }
                }
            })
            .catch(() => {})

        axios.get(
            config.url+'/get/usuarios',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: string[] }) => {
                this.props.setUsuarios(res.data)
            })
            .catch(() => {})

        axios.get(
            config.url+'/get/level',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: number }) => {
                this.props.setLevel(res.data)
            })
            .catch(() => {})

        this.props.setPrincipalUsuario(`${userService.getUser()}`)

        axios.get(
            config.url+'/get/all/stations',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: Record<string, any>[] }) => {
                this.props.setEstaciones(res.data)
            })
            .catch(() => {})

        axios.get(
            config.url+'/get/sensor/types',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: Record<string, any>[] }) => {
                this.props.setSensores(res.data)
            })
            .catch(() => {})

    }

    chooseSection = (section: ISections): ReactNode => {
        switch (section) {
            case 'principal':
                return <Principal/>
            case 'crear_parcela':
                return <CrearParcela/>
            case 'propiedades':
                return <Propiedades/>
            case 'Gestión de usuarios':
                return <GestionUsuarios/>
            case "visualizador":
                return <Visualizador/>
            case "riego_neto":
                return <RiegoNeto/>
            case "subir_datos":
                return <SubirDatos/>
            case "configuracion":
                return  <Configuracion/>
            case "caracterizacion":
                return <Caracterizacion/>
            case "estaciones":
                return <EstacionesSuelo/>
            default:
                return <div style={{marginTop: 20}}>{`Sección ${section} desconocida`}</div>
        }
    };

    chooseSectionMovile = (section: ISections): ReactNode => {
        switch (section) {
            case 'principal':
                return <PrincipalMobile/>
            case "riego_neto":
                return <RiegoNetoMobile/>
            case "visualizador":
                return <VisualizadorMobile/>
            case "configuracion":
                return  <MobileConfiguracion/>
            case "caracterizacion":
                return <MobileCaracterizacion/>
            default:
                return <div style={{marginTop: 20}}>{`Sección ${section} desconocida`}</div>
        }
    };

    render() {
        if (isBrowser && !resolucion_tablet()) {
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        flex: 1,
                        height: '100vh',
                        alignItems: 'center',
                        width: '100vw'
                    }}
                >
                    {['principal', 'riego_neto', 'subir_datos', 'configuracion', 'Gestión de usuarios', 'estaciones'].includes(this.props.section) &&
                        <NavBar handleMenu={() => this.setState({menu: true})}/>
                    }
                    <Notificacion/>
                    <Loading/>
                    <ActivarCuenta/>
                    <CrearNota/>
                    <EditarNota/>
                    <EstacionSensores/>
                    <ConfirmacionEliminar/>
                    <ConfirmacionEliminarUsuario/>
                    <NewUser/>
                    <Estaciones/>
                    <CustomSnackbar
                        open={this.props.notification != null}
                        variant={(this.props.notification != null) ? this.props.notification.variant: "info"}
                        message={this.props.notification && this.props.notification.message}
                        autoHideDuration={5000}
                        onClose={this.props.closeNotification}
                    />
                    <div
                        style={{
                            height: '100vh',
                            width: '100vw'
                        }}
                    >
                        {this.chooseSection(this.props.section)}
                    </div>
                    {this.props.cargando &&
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: "center",
                                height: '100vh',
                                width: '100vw',
                                marginLeft: '-100vw',
                                zIndex: 5,
                                backgroundColor: 'rgba(0,0,0,0.6)'
                            }}
                        >
                            <CircularProgress
                                style={{
                                    height: '20vh',
                                    width: '20vh',
                                    color: "#b43333"
                                }}
                            />
                        </div>
                    }
                </div>
            )
        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        flex: 1,
                        height: '100vh',
                        alignItems: 'center',
                        width: '100vw'
                    }}
                >
                    {['principal', 'riego_neto', 'configuracion'].includes(this.props.section) &&
                        <NavBarMobile handleMenu={() => this.setState({menu: true})}/>
                    }
                    <Notificacion/>
                    <Loading/>
                    <MobileActivarCuenta/>
                    <MobileCrearNota/>
                    <MobileEditarNota/>
                    <Estaciones/>
                    <CustomSnackbar
                        open={this.props.notification != null}
                        variant={(this.props.notification != null) ? this.props.notification.variant: "info"}
                        message={this.props.notification && this.props.notification.message}
                        autoHideDuration={5000}
                        onClose={this.props.closeNotification}
                    />
                    <div
                        style={{
                            height: '100vh',
                            width: '100vw'
                        }}
                    >
                        {this.chooseSectionMovile(this.props.section)}
                    </div>
                    {this.props.cargando &&
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: "center",
                                height: '100vh',
                                width: '100vw',
                                marginLeft: '-100vw',
                                zIndex: 500,
                                backgroundColor: 'rgba(0,0,0,0.6)'
                            }}
                        >
                            <CircularProgress
                                style={{
                                    height: '20vh',
                                    width: '20vh',
                                    color: "#b43333"
                                }}
                            />
                        </div>
                    }
                </div>
            )
        }

    }
}

const mapStateToProps = (state: IStore) => ({
    notification: state.navegacion.notification,
    section: state.navegacion.section,
    parcelas: state.principal.parcelas,
    usuario: state.principal.usuario,
    cargando: state.navegacion.cargando,
    reload: state.navegacion.reload,
    idioma: state.config.idioma,
    pronostico: state.riego.pronostico
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    closeNotification: () => dispatch({type: "notify", notification: null}),
    setParcelas: (parcelas: IParcela[]) => dispatch({type: "set-principal-parcelas", parcelas}),
    setUsuarios: (usuarios: string[]) => dispatch({type: "set-principal-usuarios", usuarios}),
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    setLevel: (level: number) => dispatch({type: "set-level", level}),
    setPrincipalUsuario: (usuario: string) => dispatch({type: "set-principal-usuario", usuario}),
    setElTiempoLatLon: (elTiempoLatLon: IPointCoords) => dispatch({type: "set-eltiempo_latlon", elTiempoLatLon}),
    setParcela: (parcela: string) => dispatch({type: "set-parcela", parcela}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
    setRiego: (riego: Record<string, Record<string, number>>) => dispatch({type: "set-riego-riego", riego}),
    setPronostico: (pronostico: Record<string, Record<string, number>>) => dispatch({type: "set-riego-pronostico", pronostico}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    Cargando: (cargando: boolean) => dispatch({type: "cargando", cargando}),
    Reload: (reload: boolean) => dispatch({type: 'reload', reload}),
    activarCuenta: (callback: boolean) => dispatch({type: 'open-activar-cuenta-dialog', callback}),
    changeLanguage: (idioma: string) => dispatch({type: 'choose-config-idioma', idioma}),
    setEstaciones: (estaciones: Record<string, any>[]) => dispatch({type: "set-principal-estaciones", estaciones}),
    setSensores: (sensores: Record<string, any>[]) => dispatch({type: "set-principal-sensores", sensores})
});

export default connect(mapStateToProps, mapDispatchToProps)(CropSenseApp);
